'use strict';

var styled = require('styled-components');
var styles = require('../Anchor/styles.js');
var component = require('../Icon/component.js');
require('react');
require('../Tooltip/component.js');
var component$1 = require('../Overlay/component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const DropdownIcon = styled__default.default(component.Icon) `
  font-size: ${({ theme }) => theme.designTokens.headerNavItemDropdownIconFontSize};
  padding: 0 ${({ theme }) => theme.designTokens.headerNavItemDropdownIconPaddingX};
`;
const isActiveStyles = styled.css `
  ${styles.Styled.Anchor},
  ${DropdownIcon} {
    color: ${({ theme }) => theme.designTokens.headerNavItemAnchorActiveTextColor};
  }
`;
const isInactiveStyles = styled.css `
  ${styles.Styled.Anchor},
  ${DropdownIcon} {
    color: ${({ theme }) => theme.designTokens.headerNavItemAnchorTextColor};
  }
  &:hover,
  &.hover,
  &:focus-within,
  &.focus-within {
    ${styles.Styled.Anchor},
    ${DropdownIcon} {
      color: ${({ theme }) => theme.designTokens.headerNavItemAnchorActiveTextColor};
    }
  }
`;
const Tab = styled__default.default.div `
  cursor: pointer;
  padding: 0 ${({ theme }) => theme.designTokens.headerNavItemPaddingX};

  ${({ isActive }) => (isActive ? isActiveStyles : isInactiveStyles)}
  && * {
    text-decoration: none;
  }
`;
const TabletSummary = styled__default.default.div `
  padding: ${({ theme }) => theme.space.component.y.m} 0;
`;
const StyledOverlay = styled__default.default(component$1.Overlay) `
  border-radius: ${({ theme }) => theme.designTokens.headerNavItemOverlayRadius};
  padding: ${({ theme }) => theme.designTokens.headerNavItemOverlayPaddingY} 0;
`;
const Styled = {
    Tab,
    TabletSummary,
    Overlay: StyledOverlay,
    DropdownIcon,
};

exports.Styled = Styled;
//# sourceMappingURL=styles.js.map
